import React from "react"
import ResponseModal from "../../../modules/blog/blogList/components/shared/blogListForm/components/ResponseModal/ResponseModal"
import BlogPreviewForm from "../../../modules/blog/blogPreviewMainContainer/blogPreview/components/shared/blogPreviewForm/BlogPreviewForm"
import Style from "./SubscriptionFormStyle.module.styl"
import BlogPreviewContent from "../../../modules/blog/blogPreviewMainContainer/blogPreview/components/shared/blogPreviewContent/BlogPreviewContent"
import translate from "../../../translation/translator"
import keys from "../../../translation/keys"

const SubscriptionForm = ({
  responseModal,
  handleCloseModal,
  handleEmailChange,
  handleSubmit,
  error,
  email,
  path,
  errors,
  loading,
  locale,
}) => {
  return (
    <div>
      <div className={Style.description}>
        <div className={Style.content}>
          <h2>{translate(keys.SUB_FORM_U_WANT, locale)}</h2>
          <p>{translate(keys.SUB_FORM_DESC, locale)} </p>
        </div>
      </div>
      {responseModal === false ? (
        ""
      ) : (
        <ResponseModal
          responseModal={responseModal}
          closeModal={handleCloseModal}
          error={error}
        />
      )}
      <BlogPreviewContent>
        <BlogPreviewForm
          locale={locale}
          loading={loading}
          errors={errors}
          email={email}
          path={path}
          handleChange={handleEmailChange}
          handleSubmit={handleSubmit}
        />
      </BlogPreviewContent>
    </div>
  )
}

export default SubscriptionForm
